const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 469.4 469.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 234.7,
    cy: 234.7,
    r: 234.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M388.3,218.8c-25.7,0-63.7,7.1-63.7,15.9s38,15.9,63.7,15.9s29.4-7.1,29.4-15.9 C417.7,225.9,414,218.8,388.3,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M144.8,234.7c0-8.8-38-15.9-63.7-15.9s-29.4,7.1-29.4,15.9s3.7,15.9,29.4,15.9 C106.8,250.7,144.8,243.5,144.8,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M234.7,324.6c-8.8,0-15.9,38-15.9,63.7s7.1,29.4,15.9,29.4s15.9-3.7,15.9-29.4 S243.5,324.6,234.7,324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M234.7,144.8c8.8,0,15.9-38,15.9-63.7s-7.1-29.4-15.9-29.4c-8.8,0-15.9,3.7-15.9,29.4 S225.9,144.8,234.7,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M298.3,298.3c-6.2,6.2,15.6,38.1,33.8,56.3c18.2,18.2,25.8,15.7,32,9.5s8.7-13.9-9.5-32 C336.4,313.9,304.5,292.1,298.3,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M171.1,171.1c6.2-6.2-15.6-38.1-33.8-56.3s-25.8-15.7-32-9.5s-8.7,13.9,9.5,32 C133,155.5,164.9,177.4,171.1,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M114.8,332c-18.2,18.2-15.7,25.8-9.5,32s13.9,8.7,32-9.5c18.2-18.2,40-50.1,33.8-56.3 C164.9,292,133,313.9,114.8,332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M354.6,137.4c18.2-18.2,15.7-25.8,9.5-32s-13.9-8.7-32,9.5c-18.2,18.2-40,50.1-33.8,56.3 C304.5,177.4,336.4,155.5,354.6,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M274,242h38.4v-15.5h-38.6c-1.1-4.9-3-9.5-5.8-13.5l27.4-27.4l-10.9-10.9L257,202.2 c-4-2.6-8.6-4.6-13.4-5.6v-38.9h-15.5v38.9c-4.9,1-9.4,2.9-13.5,5.5l-27.5-27.5l-10.9,10.9l27.3,27.3c-2.8,4.1-4.8,8.7-5.8,13.6 h-38.5v15.5h38.3c1,5.1,2.9,9.8,5.6,14l-27,27l10.9,10.9l26.9-26.9c4.2,2.8,9,4.9,14.1,5.9v37.9h15.5v-38c5.1-1,9.9-3.1,14-5.9 l26.9,26.9l10.9-10.9l-27.1-27.1C271.1,251.7,273,247,274,242z M235.7,258.2c-12.9,0-23.5-10.5-23.5-23.5 c0-12.9,10.5-23.5,23.5-23.5c12.9,0,23.5,10.5,23.5,23.5S248.7,258.2,235.7,258.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M235.7,128.2c-58.8,0-106.5,47.7-106.5,106.5s47.7,106.5,106.5,106.5s106.6-47.6,106.6-106.5 C342.3,175.9,294.6,128.2,235.7,128.2z M235.7,310.8c-42,0-76.1-34.1-76.1-76.1s34.1-76.1,76.1-76.1s76.1,34.1,76.1,76.1 S277.8,310.8,235.7,310.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 235.7,
    cy: 143.8,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 235.7,
    cy: 324.6,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 299.6,
    cy: 170.3,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 171.8,
    cy: 298.1,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 326.1,
    cy: 234.2,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 145.3,
    cy: 234.2,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 299.6,
    cy: 298.1,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 171.8,
    cy: 170.3,
    r: 6.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelm);
export default __webpack_public_path__ + "static/media/Helm.fbc88c7891a34676a558f4ce945280bb.svg";
export { ForwardRef as ReactComponent };